import React from 'react';
import { Typography, Box } from '@mui/material';

type WeatherStatProps = {
  label: string;
  value: string;
};

export const WeatherStat: React.FC<WeatherStatProps> = ({ label, value }) => (
  <Box textAlign="center">
    <Typography variant="caption" color="var(--color-type-primary)" display="block">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight="medium">
      {value}
    </Typography>
  </Box>
);
